import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5.75 3a1 1 0 0 0-.863.496l-1.75 3A1 1 0 0 0 3 7v12c0 1.093.907 2 2 2h14c1.093 0 2-.907 2-2V7a1 1 0 0 0-.137-.504l-1.75-3A1 1 0 0 0 18.25 3zm.574 2h11.352l1.166 2H5.158zM10 9h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }